'use client';

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import AdminLayout from '../AdminLayout';
import { EnvelopeIcon, DocumentTextIcon, ListBulletIcon } from '@heroicons/react/24/outline';

const tabs = [
    { name: 'Templates', href: '/admin-tools/email', icon: DocumentTextIcon, exact: true },
    { name: 'Logs', href: '/admin-tools/email/logs', icon: ListBulletIcon, exact: false },
    { name: 'Settings', href: '/admin-tools/email/settings', icon: ListBulletIcon, exact: true },
];

export default function EmailLayout({ children }: { children: React.ReactNode }) {
    const location = useLocation();

    return (
        <AdminLayout>
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900 flex items-center">
                    <EnvelopeIcon className="h-8 w-8 mr-2 text-blue-500" />
                    Email System
                </h1>
                <p className="mt-1 text-sm text-gray-500">
                    Manage email templates and view delivery logs.
                </p>
            </div>

            <div className="border-b border-gray-200 mb-6">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {tabs.map((tab) => {
                        const isActive = tab.exact
                            ? location.pathname === tab.href
                            : location.pathname.startsWith(tab.href);

                        return (
                            <Link
                                key={tab.name}
                                to={tab.href}
                                className={`
                  group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                  ${isActive
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                `}
                            >
                                <tab.icon
                                    className={`
                    -ml-0.5 mr-2 h-5 w-5
                    ${isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'}
                  `}
                                    aria-hidden="true"
                                />
                                {tab.name}
                            </Link>
                        );
                    })}
                </nav>
            </div>

            <div className="min-h-[500px]">
                {children}
            </div>
        </AdminLayout>
    );
}
